import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { createApi } from "./api";
import { ApiProvider } from "./api/context";
import { config } from "./config";
import { setAnalyticsSink } from "./lib/analytics";
import { captureLanding } from "./lib/landing";
import { isPlatformHost } from "./lib/site";
import { PlatformPage } from "./views/PlatformPage";
import { ToastProvider } from "./state/toast";
import "./styles.css";

// ?ref=, ?code= и (в разработке) ?hero= снимаются с адреса до первого запроса: x-hero нужен уже /hero
const landing = captureLanding(window.location.href, { allowHeroOverride: config.dev || config.mock });
if (landing.cleaned !== null) window.history.replaceState(window.history.state, "", landing.cleaned);

// Манифест героя отдаёт сервер по Host (ROUTES.manifest); в мок-режиме сервера нет —
// статический общий, как раньше
const platform = isPlatformHost(window.location.hostname, config.baseDomain, config.rootHeroSlug);
if (config.mock || platform) {
  document.querySelector('link[rel="manifest"]')?.setAttribute("href", "/manifest.static.webmanifest");
}

const root = document.getElementById("root");
if (!root) throw new Error("No #root element in index.html");

if (platform) {
  createRoot(root).render(<StrictMode><PlatformPage baseDomain={config.baseDomain} studioUrl={config.studioUrl} /></StrictMode>);
} else void createApi().then((api) => {
  // Приёмник аналитики — до первого рендера: эффекты детей срабатывают раньше эффектов App
  setAnalyticsSink((event) => api.event(event));
  // Касание ссылки креатора или партнёра: сервер запомнит, кто привёл
  if (landing.ref) api.touch(landing.ref);
  createRoot(root).render(
    <StrictMode>
      <ApiProvider api={api}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ApiProvider>
    </StrictMode>,
  );
});
